<template>
  <b-card no-body :title="name" bg-variant="primary">

    <div class="px-3 py-2">
      <h5>{{ name || 'Untitled segment' }}</h5>
      <h6> {{collectionName || 'No Collection'}}</h6>
      <b-row align-v="start" class="mt-2">
        <card-detail name="Count" :span="6">
          <span v-if="isReady">{{ count | formatInt }}</span>
          <i v-else class="fa fa-spin fa-spinner"/>
        </card-detail>
        <card-detail name="Of Portfolio" :span="6">
          <span v-if="isReady">{{ 100 * count / total | formatMoney }} %</span>
          <i v-else class="fa fa-spin fa-spinner"/>
        </card-detail>
        <!-- <card-detail name="Created on" :span="6">
          <span v-if="createdAt">{{ createdAt |  humanize }}</span>
          <span v-else>na</span>
        </card-detail> -->
      </b-row>
      <h6 v-if="createdAt"> Created {{ createdAt |  humanize }} </h6>
    </div>

    <b-card-footer class="px-2 py-1 bg-white" style="border: none;">
      <b-row align-v="center">
        <b-col :cols="10">
          <b-button
            @click="() => $emit('view')"
            variant="outline-dark"
            style="border-color: #aaaaaa"
            size="sm">
            <i class="fa fa-eye mr-1"/>
            Insights
          </b-button>
          <!-- <b-button
            size="sm"
            variant="outline-dark"
            style="border-color: #aaaaaa"
            @click="() => $emit('list')">
            <i class="fa fa-tasks mr-1"/>
            List View
          </b-button>
          -->
        </b-col>
        <b-col :cols="2" class="text-right">
          <b-dropdown
            no-caret
            right
            variant="outline-dark"
            style="border-color: #aaaaaa"
            size="sm"
            v-if="!locked">
            <template v-slot:button-content>
              <i class="fa fa-ellipsis-v"/>
            </template>
            <b-dropdown-item-button
              v-if="!locked"
              @click="() => $emit('delete')">
              <i class="fa fa-trash-o mr-1"/>
              Delete
            </b-dropdown-item-button>

            <b-dropdown-item-button
              v-if="!locked"
              @click="() => $emit('edit')">
              <i class="fa fa-pencil mr-1"/>
              Edit
            </b-dropdown-item-button>

            <b-dropdown-item-button
              v-if="!locked"
              @click="() => $emit('clone')"
              :disabled="cloning">
              <i class="fa fa-spinner fa-spin mr-1" v-if="cloning"/>
              <i class="fa fa-clone mr-1" v-else/>
              Duplicate
            </b-dropdown-item-button>

            <!-- <b-dropdown-divider v-if="!locked"/>

            <b-dropdown-item-button @click="() => $emit('view')">
              <i class="fa fa-eye mr-1"/>
              Insights
            </b-dropdown-item-button>

            <b-dropdown-item-button @click="() => $emit('list')">
              <i class="fa fa-tasks mr-1"/>
              Customer List
            </b-dropdown-item-button>

            <b-dropdown-item-button
              @click="downloadCSV"
              :disabled="cloning">
              <i class="fa fa-download mr-1"/>
              Download as CSV
            </b-dropdown-item-button> -->
          </b-dropdown>
        </b-col>
      </b-row>
    </b-card-footer>

  </b-card>
</template>

<script>
  import axios from 'axios';
  import {E_DOWNLOAD, eventHub, fullURL} from '../../utils';
  import CardDetail from '../CardDetail';

  export default {
    name: 'SegmentSummary',
    components: {CardDetail},

    props: {
      id: String,
      name: String,
      locked: Boolean,
      createdAt: String,
      cloning: Boolean,
      collection: String
    },

    data() {
      return {
        total: 0, // this.$store.getters.customerCount,
        count: undefined
      };
    },

    computed: {
      isReady() {
        return this.count || this.count === 0;
      },

      collectionName() {
        let col = this.collection;
        if (this.collection.indexOf('.csv') > -1) {
          this.$store.state.files.fileList.forEach(file => {
            if (!!file.originalName && file.id == this.collection) {
              col = file.originalName;
            }
          });
        }
        return col;
      }
    },

    created() {
      this.compute();
    },

    methods: {
      compute() {
        axios.get(fullURL(`/segment/insight/${this.id}/Count`))
          .then(({data}) => {
            this.count = data;
          })
          .catch(console.log);
        axios.get(fullURL(`/segment/insight/${this.id}/Total`))
          .then(({data}) => {
            this.total = data;
          })
          .catch(console.log);
      },

      downloadCSV() {
        eventHub.$emit(E_DOWNLOAD, {
          filter: {
            method: 'segment',
            values: {id: this.id},
          }
        });
      }
    }
  };
</script>
